(()=>{
 const root=document.querySelector('#shopify-section-knl-rotating-360');
 if(!root)return;
 const hero=root.querySelector('.ks-360-hero');
 const heading=hero?.querySelector('h1');
 if(heading?.textContent.trim()==='360° Landmine Attachment'){
  heading.replaceChildren(document.createTextNode('360° Landmine '));
  const emphasis=document.createElement('span');
  emphasis.className='lm-hero-em';
  emphasis.textContent='Attachment';
  heading.append(emphasis);
 }
 hero?.querySelectorAll('a.ks-assurance-item').forEach(link=>{
  const item=document.createElement('div');
  item.className=link.className;
  while(link.firstChild)item.append(link.firstChild);
  link.replaceWith(item);
 });
 const orbit=root.querySelector('.lm360-orbit');
 if(!orbit||matchMedia('(prefers-reduced-motion: reduce)').matches||!('IntersectionObserver' in window))return;
 const observer=new IntersectionObserver(entries=>{
  if(entries.some(entry=>entry.isIntersecting)){
   orbit.classList.add('is-seen');
   observer.disconnect();
  }
 },{threshold:.4});
 observer.observe(orbit);
})();
